export default __webpack_public_path__ + "assets/images/e9f75d70205286bcac55465378a18315.png";